import { LegalDocumentPage } from "../components/LegalDocumentPage";

/** The text lives in Firestore (`legal_documents/privacy_policy`); see LegalDocumentPage. */
export function PrivacyPolicy() {
  return <LegalDocumentPage documentId="privacy_policy" />;
}
